import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/auth-section/auth-service/auth.service';
import { take } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { AppointmentService } from '../appointment-service/appointment.service';
import { AppontmentlocalService } from '../appointment-service/appontmentlocal.service';
import { DoctorsService } from 'src/app/shared/doctor-service/doctors.service';
import { SocketsService } from 'src/app/shared/socket/sockets.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { UrlModal } from 'src/app/shared/url.model';

@Component({
  selector: 'app-appointment',
  templateUrl: './appointment.component.html',
  styleUrls: ['./appointment.component.css'],
})
export class AppointmentComponent implements OnInit {
  appArray = [];
  selectedItems:any = [];
  token: string;
  id: any;
  items:any = [];
  moment: any = moment
  date4: any = moment();
  isData = false;
  clinicId;
  isCross: boolean = false;
  config: { itemsPerPage: number; currentPage: number; totalItems: number };
  totalItems: number = 0;
  page: number = 1;
  clinicData: any;
  clinicArray = [];
  slotForm: FormGroup;
  isLoading: any = false;
  selectedApptId: String;
  openSendFileView: Boolean = false;
  isUploadingTime: Boolean = false;
  selectedFile: any;
  successFlag: boolean = false;
  receiptform: FormGroup;
  prdata: { name: any; age: any; gender: any; guardian: any; phoneNo: any; doctorName: any; amount: any; deposit: any; balance: any; startTime: any; endTime: any; clinicName: any; appointmentId:any};
  prdata0: any;
  show: boolean = false;
  testArray: any;
  member: any=null;
  ammount: any=null;
  deposit: any=null;
  paymentType: any="cash";
  members: any=[];
  test: any;
  isLoadingforPrintting: boolean;
  Curmember: any = null;
  discount: any;
  constructor(
    private appService: AppointmentService,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private appLocalService: AppontmentlocalService,
    private doctorService: DoctorsService,
    private socketService: SocketsService
  ) { }

  ngOnInit() {
    this.authService.authDataSubject.pipe(take(1)).subscribe((auth) => {
      this.token = auth._token;
      this.id = auth._id;

    this.gelAllClinic();
    });
    this.date4 = new Date();
    this.initConfig();
    this.gelAllClinic();
    this.socketService.onNewAppointmentMessage().subscribe((response: any) => {
      console.log("this is socket side", response);
      if (response && response.appointment && response.patientData && this.moment(this.date4).format('MMMM Do YYYY') == this.moment(response.appointment.appointmentDate).format('MMMM Do YYYY')) {
        let payload = response.appointment;
        payload.patientId = response.patientData;
        this.appArray.push(payload)
      };
    });
    this.slotForm = new FormGroup({
      slot: new FormControl(1)
    })
    this.receiptform = new FormGroup({
      guradian: new FormControl(null, Validators.required),
      amount: new FormControl(null, Validators.required),
      deposit: new FormControl(null, Validators.required),
      balance: new FormControl(null, Validators.required),
      discount : new FormControl(null, Validators.required),
    })
  }

  gelAllClinic() {
    this.doctorService.getAllClinic(this.id, this.token).subscribe((res) => {
      this.clinicArray = res.clinics;
      this.clinicData = this.clinicArray[0];
      this.slotForm = new FormGroup({
        slot: new FormControl(this.clinicData.slot)
      })
      this.getDocAppByDate('1', new Date());
    });
  }
  doSomething() {
    this.getDocAppByDate(this.config.currentPage, this.date4);
    console.log(this.date4);
  }
  onSendFile(apptId) {
    this.selectedApptId = apptId;
    this.openSendFileView = true;
    this.successFlag = false;
    this.selectedFile = null;
  }
  onSelectFile(file) {
    console.log("file", file);
    this.selectedFile = file;
    this.openSendFileView = false;
    alert("fileSlected")
  }
  handleUploading() {
    this.isUploadingTime = true;
    this.openSendFileView = false;
    var appointment = this.appArray.filter(app => app._id === this.selectedApptId);
    this.appService.saveLabReport(this.selectedApptId, this.token, appointment[0].patientId, this.selectedFile, appointment[0].clinicId._id).subscribe((res) => {
      console.log("this is response", res);
      this.isUploadingTime = false;
      this.successFlag = true;
    })
  }

  getAppointmentOfDoctors(page) {
    this.appService
      .getDoctorAppointment(this.id, this.token, page, this.clinicData._id)
      .subscribe((res) => {
        this.appArray = res.appArray;
        console.log("this is >>>>>", this.appArray)
        if (this.appArray && this.appArray.length > 0) {
          this.isData = true;
          this.appLocalService.saveAppArray(this.appArray);
          this.config.currentPage = res.page;
          this.config.itemsPerPage = res.limit;
          this.config.totalItems = res.total;
        }
      });
  }

  async printReciptData(data) {
    await this.getTest();
   
    this.doctorService.getAppointmentTransaction(data._id,this.token).subscribe((res:any)=>{
      console.log(res);
      this.selectedItems = res.testId.map((t)=>(t.id))
      this.testArray = res.testId;
      this.Curmember = res.memberId;
      this.ammount= res.amount;
      this.discount =  res.discount;
      this.deposit = res.deposit;
      this.paymentType =  res.patmentType;
      console.log(data, "this is print paper",this.receiptform);
      this.receiptform = new FormGroup({
        guradian: new FormControl(null, Validators.required),
        amount: new FormControl(res.amount, Validators.required),
        deposit: new FormControl(res.deposit, Validators.required),
        balance: new FormControl(res.balance, Validators.required),
  
      })
      let payload = {
        appointmentId : data._id,
        appointmentNumber:data.appointmentNumber,
        address:data.address,
        name: data.patientName,
        age: data.patientAge,
        gender: data.patientGender,
        guardian: data.guardianName || null,
        phoneNo: data.patientId.phoneNo,
        doctorName: data.doctorId.name,
        amount: this.receiptform.value.amount,
        deposit: this.receiptform.value.deposit,
        balance: this.receiptform.value.balance,
        startTime: this.clinicData.tokenBookingTime[0].start,
        endTime: this.clinicData.tokenBookingTime[0].end,
        clinicName: this.clinicData.clinicName
      }
      this.prdata = payload;
      this.getMember(this.clinicData._id);
    },(error)=>{
      this.receiptform = new FormGroup({
        guradian: new FormControl(null, Validators.required),
        amount: new FormControl(null, Validators.required),
        deposit: new FormControl(null, Validators.required),
        balance: new FormControl(null, Validators.required),
  
      })
      this.testArray = [];
      this.ammount = null;
      this.discount = null;
      this.Curmember = null;
      this.deposit = null;
      this.selectedItems =[];
      console.log(data, "this is print paper",this.receiptform)
      let payload = {
        appointmentId:data._id,
        appointmentNumber:data.appointmentNumber,
        address:data.address,
        name: data.patientName,
        age: data.patientAge,
        gender: data.patientGender,
        guardian: data.guardianName || null,
        phoneNo: data.patientId.phoneNo,
        doctorName: data.doctorId.name,
        amount: this.receiptform.value.amount,
        deposit: this.receiptform.value.deposit,
        balance: this.receiptform.value.balance,
        startTime: this.clinicData.tokenBookingTime[0].start,
        endTime: this.clinicData.tokenBookingTime[0].end,
        clinicName: this.clinicData.clinicName
      }
      this.prdata = payload;
      this.getMember(this.clinicData._id);
    })
  }

  printReceipt() {
    var memberName = this.members.filter(m=>m._id === this.Curmember)[0].name;
    this.prdata0 = {...this.prdata,...{amount:this.ammount,balance:this.ammount-this.deposit,deposit:this.deposit,doctorName:memberName || '',discount:this.discount}}
    console.log(this.prdata0);
    this.doctorService.printRecipt(this.prdata0, this.token).subscribe((res: any) => {
      this.isLoadingforPrintting = false;
      
      console.log(res);
      var windowOfPdf = window.open(UrlModal._URL + '/' + res.path, '_blank');
      windowOfPdf.onloadeddata = () => {
        windowOfPdf.print();
      }
    })
  } 
  changesomthing(value){
    this.show = true
  }


  saveprint(){
      let postData = {
      testId:this.testArray,
      memberId:this.Curmember,
      amount:this.ammount,
      deposit:this.deposit,
      balance:this.ammount - this.deposit,
      paymentType:this.paymentType || "cash",
      appointmentId:this.prdata.appointmentId,
      discount:this.discount
    };
    console.log(postData);
    this.isLoadingforPrintting = true;
    this.doctorService.saveAppointmentTransaction(postData,this.token).subscribe((response)=>{
      this.printReceipt();
      
    })

  }

  getMember(clinicId){
    this.doctorService.getMember(clinicId,this.token).subscribe((res:any)=>{
      console.log(res);
      this.members= res;
      this.Curmember = this.Curmember ? this.Curmember : this.members[0]._id;
    })
  }

  onChangeTests(value){
    console.log(value.value);
    var amount = 0;
    this.testArray= [];
    value.value.map((t)=>{
      var price = this.test.filter((item)=> item.testId._id === t)[0].price;
      this.testArray.push({id:t,price:price});
      amount = amount + price;
    });
    console.log(amount);
    this.ammount = amount
    
  }
  getTest(){
    console.log(this.clinicData?._id,"this is clinicId")
    this.doctorService.getTest(this.token,this.clinicData?._id).subscribe((res:any)=>{
      this.test= res.tests;
      this.items = this.test.map((t)=>({label:t.testId.name+"("+t.price+")",value:t.testId._id}))
      console.log(this.test,"this is trsts");
    })
  }
  onChangeAmmount(value){
    console.log(value.target.value);
    this.ammount = Number(value.target.value);
  }
  onChangeDeposit(value){
    console.log(value.target.value);
    this.deposit = Number(value.target.value);
  }
  onChangeDiscount(value){
    console.log(value.target.value);
    this.discount = value.target.value;
    let amount= 0
    this.selectedItems.map((t)=>{
      var price = this.test.filter((item)=> item.testId._id === t)[0].price;
      amount = amount + price;
    });
    console.log(amount);
    this.ammount = amount;
    this.ammount = this.ammount - value.target.value;
  }
  
  onConfirmAppointment(id, appDate, appNum) {
    this.appService
      .onConfirmStatus(id, appDate, 'CONFIRMED', appNum, this.token, this.clinicData._id)
      .subscribe((res) => {
        this.getDocAppByDate(this.config.currentPage, appDate);
      });
  }

  onChangeClinic(index) {
    this.clinicData = this.clinicArray[index];
    this.slotForm = new FormGroup({
      slot: new FormControl(this.clinicData.slot)
    })
    this.getDocAppByDate(this.config.currentPage, this.date4);
  }

  onCancelAppointment(id, appDate, appNum, ClinicId) {
    console.log("this is payload", id, appDate, appNum, ClinicId)
    this.appService
      .onConfirmStatus(id, appDate, 'CANCELLED', appNum, this.token, ClinicId)
      .subscribe((res) => {
        this.getDocAppByDate(this.config.currentPage, appDate);
      });
  }

  onSearchAppointment() {
    if (this.date4) {
      this.searchAppByDate('1');
    }
  }

  onClearFilter() {
    this.date4 = null;
    this.isCross = false;
    this.appArray = this.appLocalService.getAppArray();
  }

  searchAppByDate(page) {
    const appDate = moment(this.date4).format();
    console.log(appDate + 'date ');
    this.getDocAppByDate(page, this.date4);
  }
  getDocAppByDate(page, appointmentDate) {
    this.appService
      .getDoctorAppointmentByDate(
        appointmentDate,
        this.id,
        this.token,
        page,
        this.clinicData._id
      )
      .subscribe((res) => {
        this.isCross = true;
        this.appArray = res.appArray;
        console.log("this is ???>>>>??>?>?>?>", this.appArray)
        this.isData = this.appArray.length > 0;
        this.config.itemsPerPage = res.limit;
        this.config.currentPage = res.page;
        this.config.totalItems = res.total;
      });
  }

  initConfig() {
    this.config = {
      itemsPerPage: 10,
      currentPage: 1,
      totalItems: 0,
    };
  }
  pageChanged(event) {
    this.config.currentPage = event;
    if (this.date4) {
      this.searchAppByDate(this.config.currentPage);
    } else {
      this.getDocAppByDate(this.config.currentPage, new Date());
    }
  }

  cancelAll() {
    if (this.date4) {
      this.appService
        .cancelAllAppointment(this.date4, this.token)
        .subscribe((res) => {
          this.getDocAppByDate(this.config.currentPage, this.date4);
        });
    } else {
      this.appService
        .cancelAllAppointment(new Date(), this.token)
        .subscribe((res) => {
          this.getDocAppByDate(this.config.currentPage, new Date());
        });
    }
  }

  confirmAll() {
    if (this.date4) {
      this.appService
        .onConfirmallappointmentStatus(this.date4, this.token)
        .subscribe((res) => {
          this.getDocAppByDate(this.config.currentPage, this.date4);
        });
    } else {
      this.appService
        .onConfirmallappointmentStatus(new Date(), this.token)
        .subscribe((res) => {
          this.getDocAppByDate(this.config.currentPage, new Date());
        });
    }
  }
  printAppointments(appointments: any[]) {
    const printWindow = window.open('', '', 'width=600,height=600');
    printWindow.document.open();
    printWindow.document.write(`<html><head>`);
    printWindow.document.write(`
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.5.3/dist/css/bootstrap.min.css" integrity="sha384-TX8t27EcRE3e/ihU7zmQxVncDAy5uIKz4rEkgIXeMed4M0jlfIDPvg6uqKI2xXr2" crossorigin="anonymous" >
    `);
    printWindow.document.write(`<title>${this.clinicData.clinicName}</title>`);
    printWindow.document.write('</head><body>');
    // Generate the table content from the provided appointments array
    printWindow.document.write(`<h4>Date : ${appointments[0].appointmentDate}</h4>`);
    printWindow.document.write('<table class="table table-striped">');
    printWindow.document.write(`<thead>
    <tr>
    <th scope="col">Token No.</th>
    <th scope="col">Name</th>
    <th scope="col">Age</th>
    <th scope="col"></th>
    <th scope="col"></th>
    <th scope="col"></th>
    </tr>
    </thead>`);

    printWindow.document.write('<tbody>');

    for (const appointment of appointments) {
      printWindow.document.write(`<tr>
      <th scope="row">${appointment.appointmentNumber}</th>
      <td>${appointment.patientName}</td>
      <td>${appointment.patientAge}</td>
      <td></td>
      <td></td>
      <td></td>
      </tr>`);
    }

    printWindow.document.write('</tbody></table>');

    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
  }
  //  router.post("/searchpatient", doctorController.loginDocByOtp);

  onSearchChange(query) {
    if (query == '') {
      this.getDocAppByDate(this.config.currentPage, this.date4);
    }
    {
      this.appService
        .searchPatByName(query, this.token, this.date4, this.clinicData._id
        )
        .subscribe((res) => {
          this.appArray = res.data.docs;
        });
    }
  }
  changeSlot(value) {
    this.isLoading = true;
    console.log("this is selelctor side", value.target.value);
    this.appService
      .getDoctorSlotAppointmentByDate(
        {
          appDate: this.date4,
          docId: this.id,
          token: this.token,
          page: this.config.currentPage,
          slot: value.target.value,
          clinicId: this.clinicData._id
        }
      )
      .subscribe((res) => {
        this.isCross = true;
        this.appArray = res.appArray;
        this.isLoading = false;
        this.isData = this.appArray.length > 0;
        this.config.itemsPerPage = res.limit;
        this.config.currentPage = res.page;
        this.config.totalItems = res.total;
      });
  }
}
